import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Amount from "@bappweb/amount"
import "../assets/style.scss"

const CalculationDetail = (props) => {
  return (
    <Block className="payment-details-block">
      <Element type="p" className="aylik-taksit-tutari">
        Aylık Taksit Tutarı
      </Element>
      <Amount
        delimiterResolver="lang"
        lang="tr"
        currency="TL"
        value={props.aylikOdeme}
        integerType="headline3"
      />
      <Element type="p" className="faiz-orani">
        {"Faiz Oranı % "}
        {props.faizOrani}
      </Element>
      <Element type="p" className="faiz-orani">
        {"Toplam Geri Ödeme Tutarı "}
        <Amount
          delimiterResolver="lang"
          lang="tr"
          currency="TL"
          value={props.totalPaymentAmt}
          currencyType="smallBook"
          fractionType="smallBook"
          integerType="smallBook"
        />
      </Element>
      <Element type="p" className="faiz-orani">
        {"Yıllık Maliyet Oranı "}
        {props.yearlyInterestRate}
      </Element>
    </Block>
  )
}

export default CalculationDetail
